import { useEffect, useState, useRef } from 'react'
import OdooDatabase from '../data/odoo'
import Loading from './LoadingComponent'
import TableList from './TableListViewComponent'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField';
import './css/inventory.css'
import { InputAdornment } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import * as MdIcons from "react-icons/md"
import * as AiIcons from "react-icons/ai"
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import { Link } from 'react-router-dom';

type PickPartsComponentProperties = {
    onError(error: any): void;
}

export default function PickParts(props: PickPartsComponentProperties) {
    const [loading, setLoading] = useState(false)
    const [tableKey, setTableKey] = useState(0)
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState<any[]>([])
    const [searchPartText, setSearchPartText] = useState('')
    const [searchWOText, setSearchWOText] = useState('')
    const mountedRef = useRef(true)

    const filterData = (fulldata: any[]) => {
        const newData = fulldata.filter((obj: any) => {
            return obj.part.toLocaleLowerCase().indexOf(searchPartText.toLocaleLowerCase()) >= 0 &&
                obj.wo_name.toLocaleLowerCase().indexOf(searchWOText.toLocaleLowerCase()) >= 0
        })
        newData.sort((a: any, b: any) => {
            return a.wo_id - b.wo_id
        })
        return newData
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            let newData = filterData(data)
            setFilteredData(newData)
            setTableKey(1 - tableKey)
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [searchPartText, searchWOText])

    const processData = (data: any[]) => {
        data.forEach((item: any) => {
            item.qty = `${item.actual_quantity} ${item.uom}`;
            let reference = item.product_reference
            if(reference)
                reference = `[${reference}]`
            item.part = `${reference} ${item.product_name}`
            item.qtyUOM = `${item.actual_quantity} ${item.uom}`
        })
    }

    const loadData = async () => {
        const odoo = OdooDatabase.getInstance()
        try{
            setLoading(true)
            let timeBefore = (new Date()).getTime()
            let data = await odoo.execute_kw('fieldservice.wo.parts', 'get_parts_ready_to_pick', [["", ""]])
            let timeAfter = (new Date()).getTime()
            console.log('Time', timeAfter - timeBefore)
            processData(data)
            setData(data)
            let newData = filterData(data)
            setFilteredData(newData)
            setTableKey(1 - tableKey)
            setLoading(false)
            if (!mountedRef.current) return
        }catch(err: any){
            console.log('Error', err);
            if (!mountedRef.current) return
            setLoading(false)
        }
    }

    const markPartsPicked = async() => {
        console.log('Data', data)
        let woPartsMap: Map<number, number[]> = new Map();
        data.forEach((part: any) => {
            if(part._checked) {
                let parts_ids = woPartsMap.get(part.wo_id) || []
                parts_ids.push(part.id)
                woPartsMap.set(part.wo_id, parts_ids)
            }
        });
        if(woPartsMap.size === 0){
            props.onError("Select parts to pick");
            return
        }
        setLoading(true)
        let odoo = OdooDatabase.getInstance();
        try{
            const wo_ids = Array.from(woPartsMap.keys())
            for (let i = 0; i < wo_ids.length; i++) {
                const woId = wo_ids[i]
                const partIds = woPartsMap.get(woId)
                await odoo.execute_kw('fieldservice.workorder', 'mark_parts_already_picked', [[[woId], partIds]]);
            }
            setLoading(false)
        }catch(err: any){
            console.log('Error', err);
            setLoading(false)
            props.onError(err.faultString);
            return
        }
        loadData()
    }

    useEffect(() => {
        loadData()
        return () => {
            mountedRef.current = false
        }
    }, [])

    const renderWO = (field: string, datum: any) => {
        return (<Link to={`/wo/${datum.wo_id}`}>{datum[field]}</Link>)
    }

    return (
        <Paper elevation={3} className="woitem">
            <div><Typography color="textPrimary">Parts to Pick</Typography></div>
            <div className="search_box">
                <SearchBox label="Part" searchText={searchPartText} onSearchTextChanged={setSearchPartText}/>
                <SearchBox label="WO" searchText={searchWOText} onSearchTextChanged={setSearchWOText}/>
                <IconButton onClick={()=>{loadData()}}><MdIcons.MdRefresh className="refresh_icon" size={30}/></IconButton>
            </div>
            {loading ?
                (<Loading loading={true} fullWidth={false}/>):
                (<>
                <TableList
                    key={tableKey}
                    showInitialData={true}
                    initialData={filteredData}
                    checkBoxes={true}
                    elements={[
                        {field: 'wo_name', type: 'string', header: 'WO', onRender: renderWO},
                        {field:'part', type: 'string', header: 'Part'},
                        {field:'product_description', type: 'string', header: 'Description'},
                        {field: 'qtyUOM', type: 'string', header: 'Quantity'},
                        {field: 'location', type: 'string', header: 'Location'},
                        {field: 'temp_shelf', type: 'string', header: 'Temp Shelf'},

                    ]}>
                </TableList>
                </>)
            }
            <div className="wo_app_buttons">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={markPartsPicked}
                >Mark Picked</Button>
            </div>
        </Paper>
    )
}

type SearchBoxProperties = {
    label: string;
    searchText: string;
    onSearchTextChanged(text: string): void;
}

function SearchBox(props: SearchBoxProperties) {
    return (
        <TextField type="text" variant="filled" autoComplete="off" label={props.label}
            value={props.searchText}
            onChange={(event: any) => {props.onSearchTextChanged(event.target.value)}}
            InputProps={{
                endAdornment: props.searchText !== '' ?
                    (
                        <InputAdornment position="end">
                            <IconButton onClick={()=>{props.onSearchTextChanged('')}}><AiIcons.AiFillCloseCircle/></IconButton>
                        </InputAdornment>
                    ) :
                    (<></>)
            }}
        >
        </TextField>
    )
}